import { render } from "./OrderReturnCustomerAccessoriesModal.vue?vue&type=template&id=af5a39b8&scoped=true&ts=true&lang=pug"
import script from "./OrderReturnCustomerAccessoriesModal.vue?vue&type=script&lang=ts"
export * from "./OrderReturnCustomerAccessoriesModal.vue?vue&type=script&lang=ts"

import "./OrderReturnCustomerAccessoriesModal.vue?vue&type=style&index=0&id=af5a39b8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af5a39b8"]])

export default __exports__